import type { ChecklistItem } from '../../types/schema'
import type { ChecklistBookPage } from '../../types/checklistBooks'
import {
  buildRecurringOccurrenceEntries,
  getRecurringOccurrenceMode,
  type RecurringOccurrenceEntry,
} from './recurringOccurrenceUtils'

export type MobileRecurringMode = 'DAILY' | 'WEEKLY'

export type MobileChecklistOccurrenceOption = RecurringOccurrenceEntry

export const getMobileRecurringMode = (
  item: Pick<ChecklistItem, 'checklistType'> | null | undefined,
): MobileRecurringMode | null => {
  return getRecurringOccurrenceMode(item)
}

export const buildMobileChecklistOccurrenceOptions = (
  item: Pick<ChecklistItem, 'id' | 'title' | 'checklistType' | 'occurrences'> | null | undefined,
  occurrencePages: readonly ChecklistBookPage[],
  now: Date = new Date(),
  windowDays?: number,
  timeZone?: string,
): MobileChecklistOccurrenceOption[] => {
  return buildRecurringOccurrenceEntries(item, occurrencePages, now, windowDays, timeZone)
}
